import React from 'react';
import { Path } from 'react-native-svg';
import { Icon } from './Icon';
const IconPlay = ({ color, ...props }) => (<Icon {...props}>
    <Path d="M18.9341 9.59017C21.1741 10.8834 21.1741 14.1166 18.9341 15.4098L10.04 20.5448C7.79998 21.8381 5 20.2215 5 17.635L5 7.365C5 4.77848 7.79999 3.16191 10.04 4.45517L18.9341 9.59017Z" fill={color}/>
  </Icon>);
export default IconPlay;
